module.exports = __webpack_public_path__ + "static/media/14.7cd9cf6b.jpg";